export default "__VITE_ASSET__V$KpoUUU__"